import { useState } from "react"
import { useApi } from "utils"
import { FinanceMonthlyType, FinanceSuccessFetch } from "../types/FinanceMonthlyType"


export const MonthlyApis = [
  {
    category: "FINANCIAL HEALTH",
    code_budget: "CB",
    key_description: "Cash Balance",
    url: "analytic/cash_balance/yearly"
  },
  {
    category: "FINANCIAL HEALTH",
    code_budget: "FC_CR",
    key_description: "Current Ratio",
    url: "analytic-finance/fc-current-ratio/yearly"
  },
  {
    category: "FINANCIAL HEALTH",
    code_budget: "FC_WC",
    key_description: "Working Capital",
    url: "analytic-finance/fc_working_capital/yearly"
  },
  {
    category: "FINANCIAL HEALTH",
    code_budget: "FC_DTE",
    key_description: "Debt to Equity",
    url: "analytic-finance/finance_debt_to_equity/yearly"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_R",
    key_description: "Revenue",
    url: "analytic-finance/finance_revenue/yearly"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_COS",
    key_description: "Cost Of Sales",
    url: "analytic-finance/finance_cost_of_sales/yearly"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_GM",
    key_description: "Gross Margin",
    url: "analytic-finance/finance_gross_margin_percentage/yearly"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_E",
    key_description: "Expenses",
    url: "analytic-finance/finance_expences/yearly"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_OM",
    key_description: "Operating Margin",
    url: "analytic-finance/finance_operating_margin_percentage/yearly"
  },
  {
    category: "PROFIT ENGINE",
    code_budget: "FC_NPL",
    key_description: "Net Profit / Loss",
    url: "analytic-finance/finance_net_profit/yearly"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_RPE",
    key_description: "Revenue Per Employee",
    url: "analytic-finance/finance_revenue_per_employee/yearly"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_ETER",
    key_description: "Expences To Employee Ratio",
    url: "analytic-finance/finance_expences_to_employee_ratio/yearly"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_IT",
    key_description: "Inventory Turnover",
    url: "analytic-finance/efficiency_inventory_turnover/yearly"
  },
  {
    category: "EFFICIENCY",
    code_budget: "FC_AT",
    key_description: "Asset Turnover",
    url: "analytic-finance/efficiency_asset_turnover/yearly"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_ROE",
    key_description: "Return On Equity",
    url: "analytic-finance/investor_return_on_equity/monthly"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_ROA",
    key_description: "Return On Asset",
    url: "analytic-finance/investor_return_on_asset/monthly"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_EBITDA",
    key_description: "EBITDA",
    url: "analytic-finance/investor_kpi_ebitda/monthly"
  },
  {
    category: "INVESTOR KPI",
    code_budget: "KPI_DTE",
    key_description: "Debt To Equity",
    url: "analytic-finance/investor_kpi_debt_to_equity/monthly"
  },

]

export function useLFinanceMonthlyList(
  year?: number,
  location_id?: string | ""
) {
  const api = useApi()

  const [data, setData] = useState<FinanceMonthlyType[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const fetchData = async () => {
    if (!year) return

    setLoading(true)
    setError(null)

    try {
      const params: any = { year }

      if (location_id && location_id !== "") {
        params.location_id = location_id
      }

      const responses = await Promise.all(
        MonthlyApis.map(async (item) => {
          try {
            const res = await api.get(item.url, { params })

            const response: FinanceSuccessFetch = res.data
            const payload = response.payload?.[0]

            return {
              ...payload,
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget
            }
          } catch {
            // kalau API salah satu gagal tetap return row kosong
            return {
              category: item.category,
              key_description: item.key_description,
              code_budget: item.code_budget,
              budget: "",
              average: "",
              january: null,
              february: null,
              march: null,
              april: null,
              may: null,
              june: null,
              july: null,
              august: null,
              september: null,
              october: null,
              november: null,
              december: null
            }
          }
        })
      )

      setData(responses)

    } catch (err: any) {
      setError(err?.response?.data?.message || "Failed to fetch data")
      setData([])
    } finally {
      setLoading(false)
    }
  }

  const refetchLiquidity = () => fetchData()

  return {
    monthlyData: data,
    loading,
    error,
    refetchLiquidity
  }
}